export default {
  text: 'Ansaitsit {{points}} pistettä ({{amount}}) tästä tilauksesta',
  button: 'Kirjaudu sisään ja lunasta pisteet',
};
